import { module } from "../app";

module.directive("numberInputValidate", function () {
  return {
    restrict: "A",

    scope: {
      numberInputValidate: '=',
      min: '=',
      max: '='
    },
    link: function (scope, element, attrs) {
      scope.$watch('numberInputValidate', function () {
        if (scope.numberInputValidate) {
          var numberString = '' + scope.numberInputValidate;
          numberString = numberString.replace(/[^\d]/g, '');
          scope.numberInputValidate = parseInt(numberString);
          if (scope.numberInputValidate < scope.min) {
            scope.numberInputValidate = scope.min;
          } else if (scope.numberInputValidate > scope.max) {
            scope.numberInputValidate = scope.max;
          }
        } else {
          scope.numberInputValidate = scope.min;
        }
      });
    }
  };
});


// WEBPACK FOOTER //
// ./src/scripts/directives/numberInputValidate.js